export default function authHeader() {
  let user = JSON.parse(localStorage.getItem('user'));

  if (user && user.token) {
    return { 'X-API-KEY': user.token };
  } else {
    return {};
  }
}
